<form class="form hide-mobile hide-tablet">
  <div class="container">
    <!-- FORM INPUTS -->
    <div class="row is-flex">
      <div class="col s12 button-wrapper">
        <button
          (click)="onLogin()"
          cdkFocusInitial
          class="btn btn-primary"
          name="login"
          data-cy="login"
          cy-id="2021_08_03-11_13_47"
          type="button"
          [disabled]="pending$ | async"
          style="margin-bottom: 12px; width: 250px"
          ecpClickTracker="Login"
          ecpClickAction="User Clicks Login"
          ecpClickType="Button"
        >
          <!-- style="width:  30px; margin-bottom: 12px;"-->
          Login @if (pending$ | async) {
          <fa-icon icon="spinner" [spin]="true"></fa-icon>
          }
        </button>
        <!-- <mat-hint><span routerLink="/auth/essiloradmin">Login as Essilor Employee</span></mat-hint> -->
      </div>
    </div>
    <!-- INVALID CREDENTIALS MESSAGE -->
    @if ((error$ | async) && (error$ | async) !== 'PASSWORD_EXPIRED') {
    <div class="row is-flex">
      <div class="col m4 s10">
        <span class="text-semibold text-block text-warn mb-20 error-message">
          <fa-icon icon="exclamation-triangle"></fa-icon> Email or password are invalid, please try again.
        </span>
      </div>
    </div>
    }
  </div>
</form>
